import { Typography, styled } from "@mui/material"

import { TextField as UiTextField } from "../TextField"

export const TextField = styled(UiTextField, { shouldForwardProp: (prop) => prop !== "hasSeparator" })(({ hasSeparator, theme }) => ({
    "& .MuiInputBase-input": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        borderRight: hasSeparator ? `2px solid ${theme.palette["_components/input/enabledBorder"].main}` : 0,
        paddingRight: theme.spacing(1),
    },
}))

export const ExtensionAdornment = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/disabled"].main,
    textTransform: "uppercase",
    paddingLeft: 10,
    minWidth: 42,
}))